import React from 'react';
import i18next from 'i18next';
import Panel from '../../Panel/Panel';
import { Scrollbars } from 'react-custom-scrollbars';
import { ModalsConsumer } from '../../Modal/ModalsProvider';
import { normalizeNum } from '../../../utils';
import History from '../History/History';

class ShortHistory extends React.Component {
  openFullHistory = (hash, cf, showModal) => {
    showModal(<History hash={hash} cf={cf} />);
  };

  render() {
    const { history } = this.props;
    return (
      <div className="crash-short-history">
        <Panel title={i18next.t('crash.panel_history')}>
          <ModalsConsumer>
            {({ showModal }) => (
              <Scrollbars
                style={{ height: '100%' }}
                hideTracksWhenNotNeeded={true}
              >
                {history.map((item) => {
                  const cf = +item.cf;
                  const className =
                    'crash-short-history__value crash-short-history__value--' +
                    (cf >= 7 ? 'yellow' : cf >= 1.3 ? 'blue' : 'red');
                  return (
                    <span
                      key={item.id}
                      className={className}
                      onClick={this.openFullHistory.bind(
                        this,
                        item.sha512,
                        cf,
                        showModal
                      )}
                    >
                      {normalizeNum(cf)}x
                    </span>
                  );
                })}
              </Scrollbars>
            )}
          </ModalsConsumer>
        </Panel>
      </div>
    );
  }
}

export default ShortHistory;



// WEBPACK FOOTER //
// ./app/components/CrashGame/ShortHistory/ShortHistory.jsx